// NOTICE: KAPTION-INTEGRATION - realtime-auth.SEC.1 (CW-H4)
// Providers for BaseActionCableConnector's `cableTokenProvider`: they fetch a
// short-lived RoomChannel token from an authenticated endpoint.

export const agentCableTokenProvider = httpClient => async () => {
  const { data } = await httpClient.get('/api/v1/profile/kaption_cable_token');
  return data?.cable_token || null;
};

export const widgetCableTokenProvider = (httpClient, search) => async () => {
  const { data } = await httpClient.get(
    `/api/v1/widget/kaption_cable_token${search || ''}`
  );
  return data?.cable_token || null;
};
